export default __webpack_public_path__ + "static/media/google-app (1).03b1aaa7.png";